import * as types from "../constants/actionTypes";

export function clearAlert(index) {
  return function (dispatch) {
    return dispatch({
      type: types.CLEAR_ALERT,
      index: index
    });
  };
}